import React from "react"

import {startsWith} from "lodash"
import PropTypes from "prop-types"

import Link from "../Link/link"
import Typography, {TYPOGRAPHY_VARIANTS} from "../Typography"

import "./style.scss"

export const STYLED_TYPOGRAPHY_VARIANTS = {
    BIG_BOLD_LIGHT_BLUE: "big-bold-light-blue",
    BLACK: "black",
    BOLD_BLACK: "bold-black",
    BOLD_DARK_BLUE: "bold-dark-blue",
    BOLD_DARK_GREY: "bold-dark-grey",
    BOLD_LIGHT_BLUE: "bold-light-blue",
    BOLD_PINK: "bold-pink",
    BOLD: "bold",
    DARK_BLUE: "dark-blue",
    DARK_GREY: "dark-grey",
    DEFAULT: "default",
    ITALIC: "italic",
    LIGHT_BLUE: "light-blue",
    SMALL_BOLD_DARK_GREY: "small-bold-dark-grey",
    SMALL_DARK_GREY: "small-dark-grey",
    SMALL_ITALIC_DARK_GREY: "small-italic-dark-grey",
    SUP_DARK_BLUE: "sup-dark-blue",
    SUP_DARK_GREY: "sup-dark-grey",
    SUP_LIGHT_BLUE: "sup-light-blue",
    SUP: "sup",
}

const VARIANT_CLASS_MAP = {
    [STYLED_TYPOGRAPHY_VARIANTS.BIG_BOLD_LIGHT_BLUE]: "tv-big tv-bold tv-light-blue",
    [STYLED_TYPOGRAPHY_VARIANTS.BLACK]: "tv-black",
    [STYLED_TYPOGRAPHY_VARIANTS.BOLD_BLACK]: "tv-bold tv-black",
    [STYLED_TYPOGRAPHY_VARIANTS.BOLD_DARK_BLUE]: "tv-bold tv-dark-blue",
    [STYLED_TYPOGRAPHY_VARIANTS.BOLD_DARK_GREY]: "tv-bold tv-dark-grey",
    [STYLED_TYPOGRAPHY_VARIANTS.BOLD_LIGHT_BLUE]: "tv-bold tv-light-blue",
    [STYLED_TYPOGRAPHY_VARIANTS.BOLD_PINK]: "tv-bold tv-pink",
    [STYLED_TYPOGRAPHY_VARIANTS.BOLD]: "tv-bold",
    [STYLED_TYPOGRAPHY_VARIANTS.DARK_BLUE]: "tv-dark-blue",
    [STYLED_TYPOGRAPHY_VARIANTS.DARK_GREY]: "tv-dark-grey",
    [STYLED_TYPOGRAPHY_VARIANTS.DEFAULT]: "",
    [STYLED_TYPOGRAPHY_VARIANTS.ITALIC]: "tv-italic",
    [STYLED_TYPOGRAPHY_VARIANTS.LIGHT_BLUE]: "tv-light-blue",
    [STYLED_TYPOGRAPHY_VARIANTS.SMALL_BOLD_DARK_GREY]: "tv-small tv-bold tv-dark-grey",
    [STYLED_TYPOGRAPHY_VARIANTS.SMALL_DARK_GREY]: "tv-small tv-dark-grey",
    [STYLED_TYPOGRAPHY_VARIANTS.SMALL_ITALIC_DARK_GREY]: "tv-small tv-italic tv-dark-grey",
    [STYLED_TYPOGRAPHY_VARIANTS.SUP_DARK_BLUE]: "tv-dark-blue",
    [STYLED_TYPOGRAPHY_VARIANTS.SUP_DARK_GREY]: "tv-dark-grey",
    [STYLED_TYPOGRAPHY_VARIANTS.SUP_LIGHT_BLUE]: "tv-light-blue",
    [STYLED_TYPOGRAPHY_VARIANTS.SUP]: "",
}

/**
 * Permet de styliser facilement certaines portions d'un texte.
 * Voir exemples dans le /style-guide
 */
const StyledTypography = ({as = TYPOGRAPHY_VARIANTS.PARAGRAPH, className, texts, variant}) => {
    return (
        <Typography as={as} className={`styled-paragraph${className ? ` ${className}` : ""}`} variant={variant}>
            {texts.map(textProps => {
                // Affichage d'un lien
                if (textProps.linkProps) {
                    return <Link {...textProps.linkProps}>{textProps.text}</Link>
                }

                // Styles avec une balise <sup>
                if (textProps.textVariant && startsWith(textProps.textVariant, "sup")) {
                    return <sup className={VARIANT_CLASS_MAP[textProps.textVariant] || ""}>{textProps.text}</sup>
                }

                // Styles avec une balise <span>
                return (
                    <>
                        {textProps.newLine && <br />}
                        <span
                            className={VARIANT_CLASS_MAP[textProps.textVariant] || ""}
                            style={textProps.paddingLeft ? {paddingLeft: textProps.paddingLeft} : undefined}
                        >
                            {textProps.text}
                        </span>
                    </>
                )
            })}
        </Typography>
    )
}

StyledTypography.propTypes = {
    as: PropTypes.oneOf(Object.values(TYPOGRAPHY_VARIANTS)),
    className: PropTypes.string,
    texts: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string.isRequired,
            textVariant: PropTypes.oneOf(Object.values(STYLED_TYPOGRAPHY_VARIANTS)),
            linkProps: PropTypes.object,
            paddingLeft: PropTypes.string,
        }),
    ).isRequired,
    variant: PropTypes.oneOf(Object.values(TYPOGRAPHY_VARIANTS)),
}

export default StyledTypography
